import { Component, OnInit } from '@angular/core';
import { ProjectDetailInstance } from '../project-detail.instance';
import { CreateProjectModal } from '../../create-projekt-modal/create-project-modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectService } from '../../project.service';
import { Project } from '../../../models/project';

@Component({
  selector: 'app-project-detail-main',
  templateUrl: './project-detail-main.component.html',
  styleUrls: ['./project-detail-main.component.scss']
})
export class ProjectDetailMainComponent implements OnInit {
  private moveProjectSelection: Project;
  private isMoving: boolean = false;
  private clientProjects: Project[];

  //private project: Project;

  constructor(private instance: ProjectDetailInstance,
              private projectService: ProjectService,
              private modal: NgbModal) {
  }

  ngOnInit() {
  }

  createProject() {
    const modalRef = this.modal.open(CreateProjectModal);
    modalRef.componentInstance.initNew(this.project.client, this.project);
    modalRef.result.then((project) => {

      this.instance.reload();
    }, (reason) => {
      console.log(reason);
    });
  }

  onProjectChange() {
    this.instance.reload();
  }

  onMoveProjectSelected(project: Project) {
    this.moveProjectSelection = project;
  }

  moveProjectToRoot() {
    this.projectService.move(this.project, null).subscribe((project) => {
      this.instance.reload();
    });
  }

  moveProject() {
    this.projectService.move(this.project, this.moveProjectSelection).subscribe((project) => {
      this.instance.reload();
    });
  }

  showEdit() {

  }

  showMove() {
    this.projectService.getProjectTreeForClient(this.project.client.id).subscribe(tree => {
      this.isMoving = true;
      this.clientProjects = tree;
    });
  }

  get root() {
    return this.instance.rootProject;
  }

  get project() {
    return this.instance.project;
  }

}



// WEBPACK FOOTER //
// ./src/app/projects/detail/project-detail-main/project-detail-main.component.ts